'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('@deskpro/apps-components-style');

var _Action = require('../Action');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} iconUrl
 * @param {string} title
 * @param {string|Number} badgeText
 * @param  children
 * @param {string} className
 * @return {AppBar}
 * @constructor
 */
var AppBar = function AppBar(_ref) {
  var iconUrl = _ref.iconUrl,
      title = _ref.title,
      badgeText = _ref.badgeText,
      children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("dp-AppBar dp-Level", className) },
    _react2.default.createElement(
      'div',
      { className: 'dp-LevelLeft' },
      _react2.default.createElement(
        'div',
        { className: 'dp-AppBarIcon-wrap' },
        iconUrl && _react2.default.createElement(
          'i',
          { className: 'dp-Icon' },
          _react2.default.createElement('img', { src: iconUrl, alt: title })
        ),
        badgeText && _react2.default.createElement(
          'span',
          { className: 'dp-IconBadge' },
          badgeText
        )
      ),
      _react2.default.createElement(
        'span',
        { className: 'dp-AppBarTitle' },
        title
      )
    ),
    _react2.default.Children.count(children) > 0 && _react2.default.createElement(
      'div',
      { className: 'dp-LevelRight' },
      _react2.default.createElement(
        _Action.ActionList,
        null,
        children
      )
    )
  );
};

AppBar.propTypes = {
  /**
   * The url to the icon displayed in the bar
   */
  iconUrl: _propTypes2.default.string,

  /**
   * The title displayed in the bar
   */
  title: _propTypes2.default.string,

  /**
   * The text or number to display in the badge
   */
  badgeText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string
};

exports.default = AppBar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/AppBar/AppBar.js
// module id = 337
// module chunks = 0